import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableEmptyStateComponent } from '@shared-modules/table-shared/_components';
import { AppRoutes } from '@shared/helpers';
import { initializeDashboardExpiringSamplesTableColumns } from '../../_core/helpers';
import { DashboardService } from '../../_core/services/dashboard.service';
import { ExpiringSamplesTableRowComponent } from './expiring-samples-table-row/expiring-samples-table-row.component';

@Component({
    selector: 'app-expiring-samples-table',
    standalone: true,
    imports: [TableEmptyStateComponent, TranslateModule, ExpiringSamplesTableRowComponent, NgTemplateOutlet],
    templateUrl: './expiring-samples-table.component.html',
    styleUrls: ['./expiring-samples-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpiringSamplesTableComponent {
    readonly expiringSamplesList = computed(
        () => this.dashboardService.dashboardData().expiringSamplesData.expiringSamples
    );
    readonly orderSetupRoute = computed(() => AppRoutes.routes().ORDERS_SETUP);

    readonly columns = initializeDashboardExpiringSamplesTableColumns();

    constructor(private dashboardService: DashboardService) {}
}
